import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAltiumdesignerComponent } from './simple-icons-altiumdesigner.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAltiumdesignerComponent ],
    exports:      [ SimpleIconsAltiumdesignerComponent ],
    bootstrap:    []
})
export class SimpleIconsAltiumdesignerModule {}
